import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/tokens.css";
import RealSynqExplorer from "./components/RealSynqExplorer";
import { submitOnboarding } from "./lib/api";

class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: Error | null }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{
          padding: 40,
          fontFamily: "JetBrains Mono, monospace",
          background: "#05090f",
          color: "#fb7185",
          minHeight: "100vh",
        }}>
          <div style={{ fontSize: 11, color: "#5eead4", marginBottom: 12, letterSpacing: "0.15em" }}>
            ◆ RENDER ERROR — share this with the developer
          </div>
          <pre style={{ fontSize: 12, lineHeight: 1.6, color: "#e8eef7", whiteSpace: "pre-wrap" }}>
            {this.state.error.message}
            {"\n\n"}
            {this.state.error.stack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <RealSynqExplorer onOnboardingSubmit={submitOnboarding} />
    </ErrorBoundary>
  </React.StrictMode>
);
